import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import CreditCard02 from "@untitled-ui/icons-react/build/esm/CreditCard02";
import Edit02 from "@untitled-ui/icons-react/build/esm/Edit02";
import HelpCircle from "@untitled-ui/icons-react/build/esm/HelpCircle";
import Settings03 from "@untitled-ui/icons-react/build/esm/Settings03";
import { Fragment, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import noImage from "../../../assets/images/no-image.png";
import { accountStatusColors, getSpanWithColor } from "../../../utils/CardUtils";
import { hasNavigationAccess } from "../../../utils/onboardingHelper";

// #region  SCOPED CSS
const StyledPage = styled.div`
    &.main-sidebar {
        background: linear-gradient(180deg, rgba(36, 38, 39, 0.65), rgba(15, 17, 18, 0.96)), #141617;
        color: #f5f5f5;
        border-right: 1px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        backdrop-filter: blur(16px);
        width: 220px;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .id-area {
        flex: 0 0 auto;
    }

    .bottom-section {
        flex: 0 0 auto;
    }

    .menu-buttons-container {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #4a4d4e transparent;
        padding: 4px 8px 8px;
        box-sizing: border-box;
    }

    .menu-buttons-container::-webkit-scrollbar {
        width: 4px;
    }

    .menu-buttons-container::-webkit-scrollbar-thumb {
        background-color: #4a4d4e;
        border-radius: 8px;
    }

    .id-logo {
        text-align: center;
        padding: 0;
    }

    .logo-band {
        height: var(--bostager-main-header-height);
        box-sizing: border-box;
        background: #0e0f10;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
    }

    .menu-buttons-container ul li.navigation-group-heading {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        margin: 12px 0 6px;
        padding: 10px 10px 0 16px;
        font-size: 9px;
        text-align: left;
        line-height: 1.4;
        font-weight: 500;
        color: #efbf73;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }

    .logo-name {
        font-family: Roboto;
        position: relative;
        height: 56px;
        margin: 0 12px;
        width: calc(100% - 24px);
        padding: 0 !important;
    }

    .logo-name > img {
        height: 56px;
        object-fit: contain;
        width: 100%;
    }

    .logo-name > .editComp {
        display: none;
    }

    .logo-name:hover > .editComp {
        display: block;
        z-index: 1555555;
        color: var(--text-icons-gray-100);
        background-color: #202323;
        border-color: #555555;
        width: 49px;
        position: absolute;
        top: 18px;
        left: calc(50% - 24px);
    }

    .id-name {
        font-size: 0.875rem;
        margin: 0 12px 6px;
        line-height: 1.35;
        overflow-wrap: anywhere;
        text-transform: uppercase;
        text-align: center;
    }

    .id-name.description {
        font-size: 10px;
        letter-spacing: 0.08em;
        color: #aeb1b2 !important;
    }

    .id-logo .id-name.text-blue-500,
    .active-company .id-name.text-blue-500 {
        color: #f5f5f5 !important;
        font-weight: 500;
    }

    .active-brand {
        position: relative;
        margin: 0 12px 6px;
        padding: 0 20px;
    }

    .active-brand .id-name {
        margin: 0;
    }

    .active-brand > button {
        position: absolute;
        top: 0;
        right: 0;
        width: 20px;
        height: 20px;
        padding: 0;
        border: 0;
        background: transparent;
        color: var(--text-inactive);
        cursor: not-allowed;
    }

    .id-details {
        margin: 16px 10px 14px;
        padding: 10px;
        background: rgba(255, 255, 255, 0.035) !important;
        border: 1px solid rgba(255, 255, 255, 0.09);
        border-radius: 8px;
    }

    .id-details .active-company {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: stretch;
        position: relative;
    }

    .id-details .active-company > .icon {
        position: absolute;
        right: 0;
        top: -2px;
    }

    .id-details .active-company > .icon svg {
        width: 12px;
        height: 12px;
        color: var(--text-icons-gray-100);
    }

    .id-details .active-company > hr {
        height: 1px;
        width: 100%;
        border: 0;
        background: rgba(255, 255, 255, 0.1);
        margin: 8px 0;
    }

    .id-details ul {
        margin: 0;
        padding: 0;
    }

    .id-details ul li {
        color: #b7babb;
        font-size: 12px;
        line-height: 1.4;
        list-style-type: none;
        margin: 0 0 6px 0;
    }

    .id-details ul li:last-child {
        margin-bottom: 0px;
    }

    .id-details ul li > .text-blue-500 {
        color: var(--text-icons-green-500) !important;
    }

    .id-details .text-orange-500,
    .id-details ul li span.orng {
        color: #efbf73 !important;
    }

    .id-details .anchor-mini-button {
        float: right;
        color: var(--text-icons-gray-300);

        border-radius: 3px;
        position: relative;
        top: -2px;
        right: 2px;
        text-align: center;
        width: 20px;
    }

    .id-details .anchor-mini-button > i {
        margin: 3px;
    }

    .id-details .anchor-mini-button:hover {
        color: var(--text-icons-gray-100);
        border-color: var(--text-icons-gray-100);
    }

    .id-details ul li.detail-chevron-row {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }

    .id-details .detail-chevron-row > button,
    .id-details .detail-chevron-row > a {
        margin-left: auto;
        flex: 0 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .id-details .detail-chevron-row .anchor-mini-button {
        float: none;
        position: static;
        top: auto;
        right: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .report-availability {
        position: relative;
    }

    .credits-placeholder > button {
        padding: 0;
        border: 0;
        background: transparent;
        cursor: not-allowed;
    }

    .report-availability > button {
        padding: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
    }

    .report-availability > button:disabled {
        cursor: not-allowed;
    }

    .report-availability > button:not(:disabled):hover,
    .report-availability > button:not(:disabled):focus-visible {
        color: #ffffff;
    }
    .report-availability > button[aria-expanded="true"] svg {
        color: #efbf73 !important;
    }

    .report-availability > button:focus-visible {
        outline: 2px solid var(--App-Accent-Outline);
        outline-offset: 2px;
    }

    .navitems-area {
        background: transparent;
        width: 100%;
    }

    .navitems-area ul {
        padding: 0;
        margin: 0;
        overflow: hidden;
    }

    .navitems-area ul li {
        display: block;
        font-size: 12px;
        list-style-type: none;
        text-align: center;
    }

    .navitems-area ul li.disabled a {
        color: #717576;
    }

    .navitems-area ul li a {
        border: 0;
        border-radius: 4px;
        color: #e2e2e2;
        display: block;
        padding: 0px;
        position: relative;
        text-align: left;
        width: 100%;
        box-sizing: border-box;
        margin: 2px 0;
        transition: background-color 120ms ease, color 120ms ease;
    }

    .menu-buttons-container ul li a {
        margin: 3px 0;
    }

    .navitems-area ul li a .navigation-beta-badge {
        position: absolute;
        top: 6px;
        right: 6px;
        padding: 3px 4px;
        border-radius: 3px;
        border: 1px solid rgba(239, 191, 115, 0.25);
        background: rgba(197, 140, 54, 0.12);
        color: #ead2ac;
        font-size: 9px;
        line-height: 1;
        text-transform: uppercase;
        pointer-events: none;
    }

    .menu-images {
        line-height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
    }

    .menu-images > .text-one-line {
        min-width: 0;
        margin-right: 38px !important;
    }

    .menu-item .menu-enabled {
        color: #b7babb !important;
    }

    .menu-item a.active .menu-enabled {
        color: #f5f5f5 !important;
    }

    .menu-img-bg {
        position: relative;
        padding: 0 10px 0 12px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .navitems-area ul li .menu-images img,
    .navitems-area.bottom-section ul li .menu-images img {
        width: 20px;
    }

    .navitems-area.bottom-section .menu-images {
        line-height: 20px;
        justify-content: center;
    }

    .navitems-area ul li a.active {
        background: rgba(239, 191, 115, 0.07);
        box-shadow: inset 2px 0 0 #efbf73;
        color: #ffffff;
        text-decoration: none;
    }

    .navitems-area ul li:not(.disabled) a:hover {
        background: rgba(255, 255, 255, 0.055);
        color: #ffffff;
        text-decoration: none;
    }

    .navitems-area ul li a:focus-visible {
        outline: 1px solid #efbf73 !important;
        outline-offset: -1px !important;
        text-decoration: none;
    }

    @media (prefers-reduced-motion: reduce) {
        .navitems-area ul li a { transition: none; }
    }

    /* Production has more company rows: keep every row and menu reachable on short screens. */
    @media (max-height: 640px) {
        &.main-sidebar {
            overflow-y: auto;
        }

        .menu-buttons-container {
            flex: 1 0 auto;
            overflow-y: visible;
        }
    }

    .navitems-area.bottom-section {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        background: transparent;
        padding: 6px;
        width: 100%;
        box-sizing: border-box;
    }

    .navitems-area.bottom-section ul {
        margin: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .navitems-area.bottom-section ul li.bottom-items {
        min-width: 0;
        height: 56px;
        flex: 1;
    }

    .navitems-area.bottom-section ul li a {
        font-size: 10px;
        padding: 8px 4px;
        text-align: center;
        height: 54px;
    }

    .navitems-area.bottom-section ul li:not(.disabled) a.active {
        box-shadow: inset 0 2px 0 #efbf73;
    }
`;
// #endregion

const ReportAvailabilityPopover = styled.div`
    position: fixed;
    z-index: 2000;
    width: 240px;
    box-sizing: border-box;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    background: #191b1d;
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.42);
    color: var(--text-icons-gray-100);

    max-width: calc(100vw - 16px);
    max-height: calc(100vh - 16px);
    overflow-y: auto;
    .report-summary-title {
        margin: 0;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #efbf73;
    }
    .report-summary-divider {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        margin: 8px 0;
    }
    .report-summary-row {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 10px;
        margin-bottom: 6px;
        font-size: 12px;
    }
    .report-summary-row:last-child { margin-bottom: 0; }
    .report-summary-label { color: #b5b8b9; }
    .report-summary-row:last-child .report-summary-label { color: #f5f5f5; font-weight: 500; }
    .report-summary-value { text-align: right; font-variant-numeric: tabular-nums; }
    .report-summary-value:not(.text-green-500) { color: #f5f5f5; }
`;

// #region GLOBALS CONFIG
const USE_FREE_TRIAL_PERIOD = true; // Will replace "BOtag Standard" to "Free" and trial period will show "-" instead of "60 days left"
// #endregion

/**
 * Represents a styled div component for the navigation bar.
 * @param {object} props - The props of the component
 * @param {string} props.className - The class name of the component
 * @param {Array} props.menuBtns - The menu buttons
 * @param {string} props.menuBtns[].title - The title of the button
 * @param {string} props.menuBtns[].to - The link of the button
 * @param {string} props.menuBtns[].icon - The icon of the button
 * @param {string} props.menuBtns[].isActive - The active state of the button
 * @param {string} props.menuBtns[].enabled - The enabled state of the button
 * @param {string} props.menuBtns[].menuOnIcon - The "on" icon of the button
 * @param {string} props.menuBtns[].menuOffIcon - The "off" icon of the button
 * @returns {JSX.Element} - The rendered component
 */
export default function NavigationBar(props) {
    // #region STATES
    const navigate = useNavigate();
    const navigations = useSelector(state => state.navigationAccesses);
    const userAppData = useSelector(state => state.userData?.userAppData);
    //const isUserOnboarding = hasUserCompletedOnboarding(navigations?.navigationAccesses) === false;

    useRef();
    const [organizationName, setOrganizationName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [navigationBarLogo, setNavigationBarLogo] = useState("");
    const [status, setStatus] = useState("");
    const [billingPlan, setBillingPlan] = useState("");
    const [trialPeriod, setTrialPeriod] = useState("");
    const [activeCompanies, setActiveCompanies] = useState("");
    const [activeRetailBrands, setActiveRetailBrands] = useState("");
    const [activeStores, setActiveStores] = useState("");
    const [activeFFCenters, setActiveFFCenters] = useState("");
    const [reportPopoverOpen, setReportPopoverOpen] = useState(false);
    const [reportPopoverPosition, setReportPopoverPosition] = useState(null);
    const sidebarRef = useRef(null);
    const reportTriggerRef = useRef(null);
    const reportPopoverRef = useRef(null);
    const [disableBilling, setDisableBilling] = useState(true);
    const [disableSupport] = useState(true);
    //const [isAgent, setIsAgent] = useState(false);

    const [hasAccessActiveCompanies, setHasAccessActiveCompanies] = useState(false);
    const [hasAccessActiveRetailBrands, setHasAccessActiveRetailBrands] = useState(false);
    const [hasAccessActiveStores, setHasAccessActiveStores] = useState(false);
    const [hasAccessActiveFFCenters, setHasAccessActiveFFCenters] = useState(false);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const interval = setInterval(refreshNavigationBar, 1000);
        return () => clearInterval(interval);
    });

    useEffect(() => {
        refreshNavigationBar();
    }, []);

    useEffect(() => {
        if (navigations?.navigationAccesses) {
            checkHasAccessPage(navigations?.navigationAccesses);
        }
    }, [navigations]);

    useEffect(() => {
        if (!reportPopoverOpen) return undefined;
        const updatePosition = () => {
            if (!sidebarRef.current || !reportTriggerRef.current) return;
            const sidebar = sidebarRef.current.getBoundingClientRect();
            const trigger = reportTriggerRef.current.getBoundingClientRect();
            const popoverWidth = reportPopoverRef.current?.getBoundingClientRect().width || 240;
            const popoverHeight = reportPopoverRef.current?.offsetHeight || 100;
            setReportPopoverPosition({
                left: Math.max(8, Math.min(sidebar.right + 8, window.innerWidth - popoverWidth - 8)),
                top: Math.max(8, Math.min(trigger.top, window.innerHeight - popoverHeight - 8))
            });
        };
        const closeOnOutsidePointer = event => {
            if (!reportTriggerRef.current?.contains(event.target) &&
                !reportPopoverRef.current?.contains(event.target)) setReportPopoverOpen(false);
        };
        const closeOnEscape = event => {
            if (event.key === "Escape") setReportPopoverOpen(false);
        };
        updatePosition();
        document.addEventListener("pointerdown", closeOnOutsidePointer);
        document.addEventListener("keydown", closeOnEscape);
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);
        return () => {
            document.removeEventListener("pointerdown", closeOnOutsidePointer);
            document.removeEventListener("keydown", closeOnEscape);
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [reportPopoverOpen]);
    // #endregion

    // #region METHODS
    const checkHasAccessPage = navigationAccesses => {
        if (!navigationAccesses) return;

        const hasAccessActiveCompaniesBTN = hasNavigationAccess(navigationAccesses, "companies");
        //navigationAccesses.companies.navigationPanel && !navigationAccesses.companies.createModeOnly;
        const hasAccessActiveRetailBrandsBTN = hasNavigationAccess(navigationAccesses, "retailBrands");
        //navigationAccesses.retailBrands.navigationPanel && !navigationAccesses.retailBrands.createModeOnly;
        const hasAccessActiveStoresBTN = hasNavigationAccess(navigationAccesses, "stores");
        //navigationAccesses.stores.navigationPanel && !navigationAccesses.stores.createModeOnly;
        const hasAccessActiveFFCentersBTN = hasNavigationAccess(navigationAccesses, "fulfillmentCenters");
        //navigationAccesses.fulfillmentCenters.navigationPanel && !navigationAccesses.fulfillmentCenters.createModeOnly;
        const hasAccessBillingBTN = navigations?.navigationAccesses?.billing?.navigationPanel;

        setHasAccessActiveCompanies(hasAccessActiveCompaniesBTN);
        setHasAccessActiveRetailBrands(hasAccessActiveRetailBrandsBTN);
        setHasAccessActiveStores(hasAccessActiveStoresBTN);
        setHasAccessActiveFFCenters(hasAccessActiveFFCentersBTN);
        setDisableBilling(!hasAccessBillingBTN);
    };

    const isEmptyLocalStorageItem = item => {
        const value = localStorage.getItem(item);
        return [null, undefined, "", "undefined", "null", "-"].includes(value);
    };

    const getLocalStorageItem = (item, defaultError = "") => {
        const value = localStorage.getItem(item);
        return isEmptyLocalStorageItem(item) ? defaultError : value;
    };

    const getTextColorClassNameForValue = value => {
        if (value === "Cancelled") return "text-red-500";
        if (value === "Free") return "text-green-500";

        const val = [null, undefined, "", "undefined", "null", 0, "0", "--", "-", "Not selected"].includes(value)
            ? "text-orange-500"
            : "text-blue-500";

        return val;
    };

    const companyHasLogo = () => {
        return ![null, undefined, "", "undefined", "null"].includes(navigationBarLogo);
    };

    const refreshNavigationBar = () => {
        const auth = localStorage.getItem("token");
        if (!auth) navigate("/login");

        setCompanyName(getLocalStorageItem("currentCompanyName"));
        setOrganizationName(getLocalStorageItem("currentOrganizationName"));
        setNavigationBarLogo(getLocalStorageItem("currentOrganizationLogo"));

        let billingPlan =
            getLocalStorageItem("subscriptionPlanStatus") === "Cancelled"
                ? "Cancelled"
                : getLocalStorageItem("billingPlan");
        if (USE_FREE_TRIAL_PERIOD && billingPlan === "BOtag Standard") billingPlan = "Free";

        setBillingPlan(billingPlan);
        setTrialPeriod(getLocalStorageItem("trialPeriod"));
        setActiveCompanies(getLocalStorageItem("activeCompanies"));
        setActiveRetailBrands(getLocalStorageItem("activeRetailBrands"));
        setActiveStores(getLocalStorageItem("activeStores"));
        setActiveFFCenters(getLocalStorageItem("activeFFCenters"));

        const status = getLocalStorageItem("status");
        setStatus(status);

        checkHasAccessPage(navigations?.navigationAccesses);
    };

    const logoClicked = () => {
        /*if (status >= 10 || status === 'Completed') {
            navigate("/account/company/logo");
        }*/
    };
    // #endregion

    // #region COMPUTED VARS
    const currentRetailBrand = userAppData?.currentRetailBrand;
    const currentRetailBrandID = typeof currentRetailBrand === "string" ? currentRetailBrand : currentRetailBrand?._id;
    const matchingRetailBrands = typeof currentRetailBrandID === "string" && currentRetailBrandID.trim() &&
        Array.isArray(userAppData?.retailBrands)
        ? userAppData.retailBrands.filter(brand => brand?._id === currentRetailBrandID)
        : [];
    const currentBrandName = typeof currentRetailBrand?.name === "string" ? currentRetailBrand.name.trim() : "";
    const matchedBrandName = matchingRetailBrands.length === 1 && typeof matchingRetailBrands[0]?.name === "string"
        ? matchingRetailBrands[0].name.trim()
        : "";
    const activeBrandName = currentBrandName || matchedBrandName || "--";

    const trialPeriodText = !localStorage.getItem("billingPlan")
        ? "Not started"
        : isNaN(parseInt(trialPeriod))
          ? ""
          : USE_FREE_TRIAL_PERIOD
            ? "-"
            : `${trialPeriod} days left`;

    const trialPeriodColorClassName =
        trialPeriodText === "Not started"
            ? "text-orange-500"
            : parseInt(trialPeriod) === 0
              ? "text-red-500"
              : parseInt(trialPeriod) > 0
                ? "text-green-500"
                : "text-orange-500";

    // #endregion

    // #region RENDER
    return (
        <StyledPage ref={sidebarRef} className={`main-sidebar ${props?.className || ""}`} role="navigation" aria-label={organizationName ? `Workspace navigation for ${organizationName}` : "Workspace navigation"}>
            <div className="id-area">
                <div className={companyHasLogo() ? "id-logo" : "id-logo no-logo"}>
                    <div className="logo-band">
                        <div className={companyHasLogo() ? "logo-name logoimg" : "logo-name"} onClick={null}>
                            {companyHasLogo() ? (
                                <>
                                    <img
                                        alt=""
                                        className="leftmainlogo"
                                        src={navigationBarLogo}
                                        style={{ paddingLeft: "16px", paddingRight: "16px" }}
                                    />
                                    {status === 100 || status === "Completed" ? (
                                        <span className="btn btn-success editComp saveIt" onClick={logoClicked}>
                                            <i className="fa-thin fa-edit saveIt"></i>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </>
                            ) : (
                                <>
                                    <img
                                        alt=""
                                        className="leftmainlogo"
                                        src={noImage}
                                        style={{ paddingLeft: "16px", paddingRight: "16px", background: "#151922" }}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    <div className="id-name description text-gray-200" style={{ marginBottom: "3px" }}>
                        Active Brand
                    </div>
                    <div className="active-brand">
                        <div className="id-name text-blue-500">{activeBrandName}</div>
                        <button type="button" disabled aria-label="Retail Brand selection unavailable">
                            <ChevronDown height="13px" />
                        </button>
                    </div>
                </div>
                <div className="id-details n-600 border-radius">
                    <div className="active-company">
                        <div className="icon hidden">
                            <ChevronDown />
                        </div>
                        <div className="id-name description text-gray-100">Active Company</div>
                        <div className={`id-name ${getTextColorClassNameForValue(companyName)} m-0`}>{companyName}</div>
                        <hr />
                    </div>
                    <ul>
                        <li>
                            <label className="pr-5px">Current Status:</label>
                            {getSpanWithColor(status, accountStatusColors, "text-orange-500")}
                        </li>
                        <li>
                            Billing Plan:
                            <span className={`${getTextColorClassNameForValue(billingPlan)} pl-5px`}>
                                {billingPlan || "Not selected"}
                            </span>
                            <Link
                                to={disableBilling ? undefined : "/billing"}
                                aria-disabled={disableBilling} tabIndex={disableBilling ? -1 : undefined}
                                onClick={e => { if (disableBilling) e.preventDefault(); }}
                                className={disableBilling ? "hover-not-allowed" : ""}>
                                <span className="anchor-mini-button">
                                    <Edit02
                                        className={!disableBilling ? "text-default cursor-pointer" : "text-inactive"}
                                        height="13px"
                                    />
                                </span>
                            </Link>
                        </li>
                        <li className="report-availability detail-chevron-row">
                            Available reports:
                            <span className="text-orange-500 pl-5px">-</span>
                            <button type="button" className="anchor-mini-button" ref={reportTriggerRef}
                                aria-label="Show report reservation details" aria-haspopup="dialog"
                                aria-expanded={reportPopoverOpen} onClick={() => setReportPopoverOpen(open => !open)}>
                                <ChevronRight className="text-gray-100" height="13px" />
                            </button>
                            {reportPopoverOpen && createPortal(<ReportAvailabilityPopover ref={reportPopoverRef}
                                className="report-availability-popover" role="dialog"
                                aria-label="Report reservation details" style={{
                                    left: reportPopoverPosition?.left ?? 0,
                                    top: reportPopoverPosition?.top ?? 0,
                                    visibility: reportPopoverPosition ? "visible" : "hidden"
                                }}>
                                <p className="report-summary-title">REPORT SUMMARY</p>
                                <div className="report-summary-divider" role="separator" />
                                {[
                                    ["Started", "started"],
                                    ["In progress", "inProgress"],
                                    ["Completed", "completed"],
                                    ["Available", "availableReports"]
                                ].map(([label, field]) => (
                                    <Fragment key={field}>
                                        {field === "availableReports" &&
                                            <div className="report-summary-divider" role="separator" />}
                                        <div className="report-summary-row">
                                            <span className="report-summary-label">{label}</span>
                                            <span className={field === "availableReports" ? "report-summary-value text-green-500" : "report-summary-value"}>
                                                -
                                            </span>
                                        </div>
                                    </Fragment>
                                ))}
                            </ReportAvailabilityPopover>, document.body)}

                        </li>
                        <li className="credits-placeholder detail-chevron-row">
                            Credits left:
                            <span className="text-orange-500 pl-5px">-</span>
                            <button type="button" className="anchor-mini-button" disabled aria-label="Credits left details unavailable">
                                <ChevronRight className="text-inactive" height="13px" />
                            </button>
                        </li>
                        <li>
                            Active FFCenters:
                            <span className={getTextColorClassNameForValue(activeFFCenters) + " pl-5px"}>
                                {activeFFCenters || "-"}
                            </span>
                            <Link
                                to={hasAccessActiveFFCenters ? "/ffcenters/management" : undefined} aria-disabled={!hasAccessActiveFFCenters} tabIndex={hasAccessActiveFFCenters ? undefined : -1} onClick={e => { if (!hasAccessActiveFFCenters) e.preventDefault(); }}
                                className={!hasAccessActiveFFCenters ? "hover-not-allowed" : "cursor-pointer"}>
                                <span className="anchor-mini-button">
                                    <ChevronRight
                                        className={hasAccessActiveFFCenters ? "text-default" : "text-inactive"}
                                        height="13px"
                                    />
                                </span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="menu-buttons-container navitems-area">
                <ul>
                    {props?.menuBtns?.map((btn, index) => {
                        const groupTitles = { intel: "BOTAG INTEL", operations: "OPERATIONS", account: "ACCOUNT" };
                        const group = groupTitles[btn.group];
                        const previousGroup = groupTitles[props.menuBtns[index - 1]?.group];
                        return <Fragment key={btn.to}>{group && previousGroup !== group && <li className="navigation-group-heading" role="heading" aria-level="2">{group}</li>}<MenuBtn btn={btn} /></Fragment>;
                    })}
                </ul>
            </div>

            <div className="navitems-area bottom-section">
                <ul>
                    <li className="bottom-items disabled">
                        <Link aria-disabled="true" tabIndex={-1} className="hover-not-allowed" onClick={e => e.preventDefault()}>
                            <div className="menu-images mb-8px">
                                <Settings03 className="disabled text-inactive" height="100%" width="16px" />
                            </div>
                            <span>Settings</span>
                        </Link>
                    </li>

                    <li className={!disableBilling ? "bottom-items" : "bottom-items disabled"}>
                        <Link
                            to={disableBilling ? undefined : "/billing"}
                                aria-disabled={disableBilling} tabIndex={disableBilling ? -1 : undefined}
                                onClick={e => { if (disableBilling) e.preventDefault(); }}
                            className={`${disableBilling ? "hover-not-allowed" : "hover-pointer"} ${
                                window.location.pathname.startsWith("/billing") ? "active" : ""
                            }`}>
                            <div className="menu-images mb-8px">
                                <CreditCard02 className="disabled" height="100%" width="16px" />
                            </div>
                            <span>Billing</span>
                        </Link>
                    </li>

                    <li className={!disableSupport ? "bottom-items" : "bottom-items disabled"}>
                        <Link
                            to={disableSupport ? undefined : "/support"}
                                aria-disabled={disableSupport} tabIndex={disableSupport ? -1 : undefined}
                                onClick={e => { if (disableSupport) e.preventDefault(); }}
                            className={`${disableSupport ? "hover-not-allowed" : "hover-pointer"} ${
                                window.location.pathname.startsWith("/support") ? "active" : ""
                            }`}>
                            <div className="menu-images mb-8px">
                                <HelpCircle className="" height="100%" width="16px" />
                            </div>
                            <span>Support</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </StyledPage>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const MenuBtn = ({ btn }) => {
    return (
        <li className={`menu-item ${btn?.enabled ? "" : "disabled"} ${btn?.isActive ? "active" : ""}`}>
            <Link
                to={btn?.enabled ? btn?.to : undefined}
                aria-disabled={!btn?.enabled}
                tabIndex={btn?.enabled ? undefined : -1}
                onClick={e => { if (!btn?.enabled) { e.preventDefault(); return; } btn?.onClick?.(e); }}
                className={`${btn?.isActive ? "active" : ""} ${btn?.enabled ? "" : "hover-not-allowed"}`}>
                <div className="menu-images">
                    <div className="menu-img-bg">
                        {btn?.icon && (
                            <span className={btn?.enabled ? "menu-enabled" : "disabled"}>
                                <i className={` fa-xl ${btn?.icon}`} aria-hidden="true"></i>
                            </span>
                        )}

                        {btn?.menuOnIcon && (
                            <img
                                alt={btn?.title}
                                className={btn?.enabled ? "menu-enabled" : "disabled"}
                                src={btn?.enabled ? btn?.menuOnIcon.icon : btn?.menuOffIcon.icon}
                            />
                        )}

                        {btn?.iconSVG && (
                            <btn.iconSVG
                                alt={btn?.title}
                                height="100%"
                                width="16px"
                                className={btn?.enabled ? "menu-enabled text-default" : "disabled text-inactive"}
                            />
                        )}
                    </div>

                    <span className="text-one-line" style={{ marginRight: "25px" }}>
                        {btn?.title}
                    </span>
                </div>
                {["nanaBO", "Buying Intel"].includes(btn?.title) && <span className="navigation-beta-badge">BETA</span>}
            </Link>
        </li>
    );
};

// #endregion
